<template>
  <nav
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" :textWhite="textWhite" />
      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >
        <div
          class="pe-md-3 d-flex align-items-center"
          :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
        </div>
        <ul class="navbar-nav justify-content-end">
          <li v-if="plan === 'NONE'" style="cursor: pointer" class="nav-item d-flex align-items-center">
            <soft-button
              @click="goToPlans()"
              class="mb-2 success"
              >free plan
            </soft-button>
          </li>
          <li v-else class="nav-item d-flex align-items-center">
            <soft-button
              style="background-color: #00E476;"
              class="mb-2"
              >{{ plan }} plan
            </soft-button>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
              href="#"
              @click="toggleSidebar"
              class="p-0 nav-link text-body"
              id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
          <li
            class="nav-item dropdown d-flex ps-3 align-items-center"
            :class="this.$store.state.isRTL ? 'ps-2' : 'pe-2'"
          >
            <a
              href="#"
              class="p-0 nav-link"
              :class="[
                textWhite ? textWhite : 'text-body',
                showMenu ? 'show' : '',
              ]"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="showMenu = !showMenu"
            >
              <i style="font-size: 20px;" class="cursor-pointer fa fa-cog fixed-plugin-button-nav"></i>
            </a>
            <ul
              class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4"
              :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton"
            > 
              <li v-show="plan === 'STARTER' || plan === 'ADVANCED' || plan === 'PREMIUM'" class="mb-2" @click="goToBilling()">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <i class="fa fa-credit-card me-1"></i> Billing
                      </h6>
                    </div>
                  </div>
                </a>
              </li>
              <li class="mb-2" @click="goToPlans()">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <i class="fa fa-bolt me-1"></i> Change plan
                      </h6>
                    </div>
                  </div>
                </a>
              </li>
              <li class="mb-2" @click="changePass()">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <i class="fas fa-lock me-1"></i> Change password
                      </h6>
                    </div>
                  </div>
                </a>
              </li>
              <li class="mb-2" data-bs-toggle="modal" data-bs-target="#LogOutModal">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <i class="fas fa-user me-1"></i> Log out
                      </h6>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- Modal New User-->
  <div class="modal fade" data-bs-backdrop="static" id="LogOutModal" tabindex="-1" aria-labelledby="LogOutModallLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="LogOutModalLabel">You are about to close your session</h5>
          
        </div>
        <div class="modal-body">
          Are you sure you want to log out?
        </div>
        <div class="modal-footer">
          <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
          <SoftButton @click="logOut()" data-bs-dismiss="modal">Go ahead</SoftButton>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions } from "vuex";
import HTFetch from "../../llamadas/HTFetch"
import SoftButton from "../../components/SoftButton.vue";
import router from '../../router';

export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
      showExtension: false,
      llamada: new HTFetch(),
      plan: ""
    };
  },

  props: ["minNav", "textWhite"],

  created() {
    this.minNav;
  },

  mounted() {
    if (!location.href.includes('sign-up')) {
      if (!location.href.includes('sign-in')) {
        if (!location.href.includes('reset-password-after-mail')) {
          if (localStorage.getItem('pack') === null) {
            this.llamada.userInfo(this.userInfoRsp.bind(this))
          } else {
            this.plan = localStorage.pack
          }
        }
      }
    }
  },
 
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },

    logOut() {
      
      this.llamada.LogOut()
    },

    changePass() {
      router.push({ name: 'Change Password' })
    },

    goToPlans() {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "upgrade-plan",
          user_id: localStorage.userId
        });
      }

      router.push({ name: 'Packs' })
    },

    goToBilling() {
      this.llamada.getStripeData(this.bringDataRsp.bind(this))
    },

    bringDataRsp(rsp) {
      if (rsp.status !== 404) {
        window.open(rsp.data.session)
      } 
    },

    userInfoRsp(rsp) {
      
      if (rsp.status !== 200) {
        console.log('arafue')
        return
      }
      
      if (rsp.data.manager === true) {
        localStorage.manager = 'true'
      } else {
        localStorage.manager = 'false'
      }
      if (rsp.data.inserter === true) {
        localStorage.inserter = 'true'
      } else {
        localStorage.inserter = 'false'
      } 

      localStorage.pack = rsp.data.premium
      this.plan = rsp.data.premium

      let collecciones = []
      for (let i = 0; i < Object.keys(rsp.data.collections).length; i++) {
        collecciones.push({
          "name": Object.keys(rsp.data.collections)[i],
          "token": Object.values(rsp.data.collections)[i]
        })
      }

      localStorage.collections = JSON.stringify(collecciones)
    }
  },

  components: {
    Breadcrumbs,
    SoftButton
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },

  /*updated() {
    const navbar = document.getElementById("navbarBlur");
    window.addEventListener("scroll", () => {
      if (window.scrollY > 10 && this.$store.state.isNavFixed) {
        //navbar.classList.add("blur");
        navbar.classList.add("position-sticky");
        navbar.classList.add("shadow-blur");
      } else {
        //navbar.classList.remove("blur");
        navbar.classList.remove("position-sticky");
        navbar.classList.remove("shadow-blur");
      }
    });
  },*/
};
</script>
